export const LANG_COOKIE_KEY = 'v5_Culture'
